import axios from "axios";
import Config from "../../../config";

const v2_actionEditCrmReason = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/reasons/${id}/editar`,
        data
    });
};

export default v2_actionEditCrmReason;
